import { createFileRoute } from '@tanstack/react-router'

import { DefaultLoader } from '#components/default-loader'
import { WorkflowDetailPage } from '#features/admin/workflows/workflow-detail-page'

export const Route = createFileRoute('/_app/admin/workflows/$id')({
  head: () => ({ meta: [{ title: 'Workflow details' }] }),
  component: RouteComponent,
  pendingComponent: DefaultLoader,
})

function RouteComponent() {
  const { id } = Route.useParams()
  return <WorkflowDetailPage workflowId={id} />
}
